"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMockXPODeliveryReceiptGenerationData = void 0;
const faker = require("faker");
const signature_1 = require("./signature");
faker.seed(100);
const baseXPODeliveryReceiptMockData = {
    proNumber: '933-510760',
    service: {
        date: '03/31/2021',
        origin: 'NTP',
        destination: 'XBY',
        route: ['NJM', 'BIG'],
    },
    stakeholders: {
        shipper: {
            name1: 'ADVANTAGE TRIM & LUMBER CO',
            address: '7524 Commerce Pl',
            city: 'Sarasota',
            state: 'FL',
            country: 'US',
            postalCode: '34234-5020',
        },
        consignee: {
            name1: 'AMY DAVID',
            address: '868 Metropolitan Ave',
            city: 'Sarasota',
            state: 'FL',
            country: 'US',
            postalCode: '34234-5020',
        },
    },
    shipperNumbers: 'SN# 56000101\nPO# SKYE REP PRO SPRING 18',
    otherReferenceNumbers: ['RQ# 5523861186281', 'BOL 458487', 'PO 0017837', 'ON 20202802', 'MS4858234', 'TEST 38482342'],
    commodities: [
        {
            piecesCount: 11,
            description: 'PALLET STRIP STEEL CLASS 50',
            weightLbs: 24096.0,
            charge: 'PPD',
        },
        {
            piecesCount: 10,
            description: 'PALLET STRIP STEEL CLASS 50 AND A SUPER SUPER SUPER SUPER SUPER SUPER LONG DESCRIPTION',
            weightLbs: 1802.3,
        },
        {
            piecesCount: 11,
            description: 'PALLET STRIP STEEL CLASS 100 000737472',
            weightLbs: 28347.7,
        },
        {
            piecesCount: 12,
            description: 'PALLET STRIP STEEL CLASS 50',
            weightLbs: 1734.0,
        },
    ],
    totalPieces: 52,
    totalWeightLbs: 83423.0,
    totalChargeText1: 'TOTAL',
    totalChargeText2: 'PPD',
    accessorials: [
        { description: 'CBL BILL OF LADING CORRECTION', code: 'CBL' },
        { description: 'CCS CALIFORNIA COMPLIANCE SURCHARGE', code: 'CCS' },
        { description: 'CBR REWEIGH OF SHIPMENT FEE', code: 'CBR' },
    ],
    poNumbers: ['SOATL 12348374', 'BPB-WCK-RP32, 234848382'],
    delivery: {
        pieceCount: 3,
        hour: 14,
        minute: 32,
        day: 17,
        month: 6,
        year: 2021,
        shrinkWrapIntact: 'yes',
        accessorials: {
            inside: true,
            residential: false,
            liftgate: true,
            construction: false,
        },
        driverName: 'driver name',
        consigneeSignatureUrl: signature_1.mockSignatureBase64,
        consigneeName: faker.name.firstName() + ' ' + faker.name.lastName(),
    },
};
const generateMockXPODeliveryReceiptGenerationData = (options) => {
    var _a, _b, _c;
    const baseModel = {
        ...baseXPODeliveryReceiptMockData,
        ...options === null || options === void 0 ? void 0 : options.overrides,
    };
    /**
     * Appointment
     */
    if (options === null || options === void 0 ? void 0 : options.appointment) {
        baseModel.notification = {
            message: 'APPT:',
            messageObservation: '*SEE DLVY NOTE',
            notificationDate: '6/11',
            notificationTime: '11:00-17:00',
            contactName: 'STEVEN',
        };
        baseModel.remarks = {
            ...((_a = baseModel.remarks) !== null && _a !== void 0 ? _a : {}),
            notification: 'DLVY NOTE: CALL  1/2 HR B4 631-836-0666',
        };
    }
    /**
     * Remarks
     */
    if (options === null || options === void 0 ? void 0 : options.remarks) {
        baseModel.remarks = {
            shipment: '*** HAZMAT EMERGENCY CONTACT PO10353922 SI10256224 ***. SHIPPERDIESEL GLOBAL LOGISTICS - LRD ( TRANSGROUP) 3 PLT .CONS PH: 770-233-5878.SHP PH: 956-645-5158',
            authority: 'COLLECT CHARGES ARE BEING PAID BY THE FOLLOWING BILL TO: ECHO GLOBAL LOGISTICS',
            canadianGoods: 'CANADIAN GST #R139842884 -0- RATED',
        };
    }
    /**
     * Commodities
     */
    /* eslint-disable */
    if ((_b = options === null || options === void 0 ? void 0 : options.commoditiesCount) !== null && _b !== void 0 ? _b : -1 >= 0) {
        baseModel.commodities = Array.apply(null, Array(options.commoditiesCount)).map(() => ({
            piecesCount: faker.datatype.number(11),
            description: faker.commerce.productDescription(),
            weightLbs: faker.datatype.number(9999),
            charge: Math.random() > 0.5 ? 'PPD' : undefined,
        }));
    }
    /**
     * Other Reference Numbers
     */
    if ((_c = options === null || options === void 0 ? void 0 : options.otherReferenceNumberCount) !== null && _c !== void 0 ? _c : -1 >= 0) {
        baseModel.otherReferenceNumbers = Array.apply(null, Array(options.otherReferenceNumberCount)).map(() => `SN ${(Math.random() * 9999999).toFixed(0)}`);
    }
    /* eslint-enable */
    return baseModel;
};
exports.generateMockXPODeliveryReceiptGenerationData = generateMockXPODeliveryReceiptGenerationData;
//# sourceMappingURL=xpoDeliveryReceipt.js.map